import b from 'b_';
import cx from 'classnames';
import React from 'react';
import { CSSTransition } from 'react-transition-group';

import './ratio-bar.scss';

export interface RatioBarItem {
    color: string;
    value: number;
}

interface Props {
    items: RatioBarItem[];
    max: number;
    progress?: boolean;
    mix?: string;
}

const MIN_RATIO_WIDTH = '3px';

export const RatioBar = (props: Props) => {
    const { items, progress, mix, max = 100 } = props;
    const gradient = getGradient(items, max);
    const shouldBeColored = !progress && gradient;

    return (
        <CSSTransition classNames="ratio-bar-animation" in={!progress} timeout={0}>
            <div className={cx(b('ratio-bar', { progress }), mix)}>
                {shouldBeColored && (
                    <div
                        className={b('ratio-bar', 'item')}
                        style={{
                            background: `linear-gradient(to right, ${gradient})`,
                        }}
                    />
                )}
            </div>
        </CSSTransition>
    );
};

function getGradient(items: RatioBarItem[], max: number) {
    if (!items.length) {
        return '';
    }

    let completed = '';
    let previous = '0%';

    items.forEach((item) => {
        if (!item.value) {
            return;
        }

        const ratio = (Math.min(max, item.value) / max) * 100;
        const current = `max(calc(${previous} + ${MIN_RATIO_WIDTH}), calc(${previous} + ${ratio}%))`;
        completed += `${item.color} ${previous} ${current}, `;

        previous = current;
    });

    completed += `transparent ${previous}`;

    return completed;
}
